import { registerLocaleData } from '@angular/common';
import localeSi from '@angular/common/locales/en-SI';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@environments/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.name === 'production') {
    enableProdMode();
}

registerLocaleData(localeSi, 'en-SI');

if (environment.name === 'local') {
    bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
} else {
    bootstrapApplication(AppComponent, appConfig);
}
